import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

const client = axios.create({ baseURL: API, timeout: 60000 });

export const api = {
  root: () => client.get("/").then((r) => r.data),
  seed: () => client.post("/seed").then((r) => r.data),
  datasetSummary: () => client.get("/dataset/summary").then((r) => r.data),
  connectors: () => client.get("/connectors").then((r) => r.data),
  graph: (focus) => client.get("/graph", { params: focus ? { focus } : {} }).then((r) => r.data),
  events: () => client.get("/events").then((r) => r.data),
  filters: () => client.get("/filters").then((r) => r.data),
  insights: (params = {}) => client.get("/insights", { params }).then((r) => r.data),
  insight: (id) => client.get(`/insights/${id}`).then((r) => r.data),
  explain: (id) => client.post(`/insights/${id}/explain`).then((r) => r.data),
  dashboard: () => client.get("/dashboard/summary").then((r) => r.data),
  orders: () => client.get("/orders").then((r) => r.data),
  fulfillment: (body) => client.post("/fulfillment", body).then((r) => r.data),
  query: (body) => client.post("/query", body).then((r) => r.data),
  feedback: (body) => client.post("/feedback", body).then((r) => r.data),
  getFeedback: (id) => client.get(`/feedback/${id}`).then((r) => r.data),

  // ---- Vans (POC2) ----
  vansSummary: () => client.get("/vans/summary").then((r) => r.data),
  vansDecisions: () => client.get("/vans/decisions").then((r) => r.data),
  vansDecision: (id) => client.get(`/vans/decisions/${id}`).then((r) => r.data),
  vansConnectors: () => client.get("/vans/connectors").then((r) => r.data),
  vansGraph: (focus) => client.get("/vans/graph", { params: focus ? { focus } : {} }).then((r) => r.data),
  vansFilters: () => client.get("/vans/filters").then((r) => r.data),
  vansQuery: (body) => client.post("/vans/query", body).then((r) => r.data),
  vansFeedback: (body) => client.post("/vans/feedback", body).then((r) => r.data),
  vansGetFeedback: (id) => client.get(`/vans/feedback/${id}`).then((r) => r.data),

  // ---- IGL (POC3) ----
  iglSummary: () => client.get("/igl/summary").then((r) => r.data),
  iglDecisions: () => client.get("/igl/decisions").then((r) => r.data),
  iglDecision: (id) => client.get(`/igl/decisions/${id}`).then((r) => r.data),
  iglRecompute: (id, disabled) => client.post(`/igl/decisions/${id}/recompute`, { disabled }).then((r) => r.data),
  iglConnectors: () => client.get("/igl/connectors").then((r) => r.data),
  iglGraph: (focus) => client.get("/igl/graph", { params: focus ? { focus } : {} }).then((r) => r.data),
  iglFilters: () => client.get("/igl/filters").then((r) => r.data),
  iglQuery: (body) => client.post("/igl/query", body).then((r) => r.data),
  iglFeedback: (body) => client.post("/igl/feedback", body).then((r) => r.data),
  iglGetFeedback: (id) => client.get(`/igl/feedback/${id}`).then((r) => r.data),

  // ---- Dalmia Bharat (POC4) ----
  dalmiaSummary: () => client.get("/dalmia/summary").then((r) => r.data),
  dalmiaDecisions: () => client.get("/dalmia/decisions").then((r) => r.data),
  dalmiaEvents: () => client.get("/dalmia/events").then((r) => r.data),
  dalmiaTrends: () => client.get("/dalmia/trends").then((r) => r.data),
  dalmiaOrders: () => client.get("/dalmia/orders").then((r) => r.data),
  dalmiaFulfillment: (body) => client.post("/dalmia/fulfillment", body).then((r) => r.data),
  dalmiaDecision: (id) => client.get(`/dalmia/decisions/${id}`).then((r) => r.data),
  dalmiaRecompute: (id, disabled) => client.post(`/dalmia/decisions/${id}/recompute`, { disabled }).then((r) => r.data),
  dalmiaConnectors: () => client.get("/dalmia/connectors").then((r) => r.data),
  dalmiaGraph: (focus) => client.get("/dalmia/graph", { params: focus ? { focus } : {} }).then((r) => r.data),
  dalmiaFilters: () => client.get("/dalmia/filters").then((r) => r.data),
  dalmiaQuery: (body) => client.post("/dalmia/query", body).then((r) => r.data),
  dalmiaFeedback: (body) => client.post("/dalmia/feedback", body).then((r) => r.data),
  dalmiaGetFeedback: (id) => client.get(`/dalmia/feedback/${id}`).then((r) => r.data),

  // ---- IGL Refuel Validation (POC-2) ----
  rvSummary: () => client.get("/iglrv/summary").then((r) => r.data),
  rvVehicles: () => client.get("/iglrv/vehicles").then((r) => r.data),
  rvVehicle: (plate) => client.get(`/iglrv/vehicles/${plate}`).then((r) => r.data),
  rvLookup: (plate) => client.post("/iglrv/lookup", { plate }).then((r) => r.data),
  rvPrevalidate: (plate) => client.post("/iglrv/prevalidate", { plate }).then((r) => r.data),
  rvConnectors: () => client.get("/iglrv/connectors").then((r) => r.data),
  rvFleet: () => client.get("/iglrv/fleet").then((r) => r.data),
  rvScanNext: () => client.get("/iglrv/scan/next").then((r) => r.data),
  rvScanStatus: () => client.get("/iglrv/scan/status").then((r) => r.data),
  rvQuery: (body) => client.post("/iglrv/query", body).then((r) => r.data),
};

export const fmtUSD = (n) => {
  if (n == null) return "—";
  const v = Number(n);
  if (v >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
  if (v >= 1e3) return `$${(v / 1e3).toFixed(1)}K`;
  return `$${v.toLocaleString("en-US")}`;
};

export const fmtINR = (n) => {
  if (n == null) return "—";
  const v = Number(n);
  if (v >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (v >= 1e5) return `₹${(v / 1e5).toFixed(2)} L`;
  if (v >= 1e3) return `₹${(v / 1e3).toFixed(1)}K`;
  return `₹${v.toLocaleString("en-IN")}`;
};

export const SEV = {
  Critical: { color: "#dc2626", bg: "#fef2f2", ring: "#fecaca" },
  High: { color: "#ea580c", bg: "#fff7ed", ring: "#fed7aa" },
  Medium: { color: "#ca8a04", bg: "#fefce8", ring: "#fde68a" },
  Low: { color: "#64748b", bg: "#f8fafc", ring: "#e2e8f0" },
};

export const NODE_COLORS = {
  dealer: "#4f46e5",
  region: "#0891b2",
  sku: "#7c3aed",
  family: "#9333ea",
  plant: "#dc2626",
  warehouse: "#059669",
  order: "#d97706",
  objective: "#0f172a",
  // IGL entity types
  station: "#dc2626",
  asset: "#4f46e5",
  workorder: "#d97706",
  incident: "#b91c1c",
  complaint: "#0891b2",
  certificate: "#7c3aed",
  center: "#059669",
  // Dalmia entity types
  depot: "#0d9488",
  truck: "#0284c7",
  supplier: "#a16207",
  material: "#65a30d",
  // IGL Refuel Validation entity types
  install: "#7c3aed",
  cylinder: "#059669",
  cylinder_x: "#dc2626",
  certificate: "#0891b2",
  center: "#b45309",
};
